<template>
  <div class="homde_head">
      <!-- 头部标题 -->
      <div class="head-title">智慧工厂数字孪生系统</div>
      <div class="jlcmLog">SUMHOO</div>
      <div class="userIcon"></div>
      <div class="login">Admin</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>

 @font-face{
    font-family: TitleFamily;
    src: url("https://sumhoo.oss-cn-shenzhen.aliyuncs.com/Fonts/TitleFamily.ttf");
  }

@font-face {
  font-family: Arboria;
  src: url("https://sumhoo.oss-cn-shenzhen.aliyuncs.com/Fonts/Arboria-Medium.otf");
}
.homde_head {
  width: 100%;
  height: 100%;
  background: url("../assets/images/header-bg1.png") no-repeat center center;
  background-size: 100% 100%;
  font-family: TitleFamily;
  display: flex;
  align-items: center;
  justify-content: right;
}
.userName {
  font-size: 25px;
  font-weight: 400;
  color: #24d8ff;
}

 .head-title {
    width: 100%;
    height: 97px;
    font-size: 41px;
    font-family: TitleFamily;
    text-align: center;
    line-height: 80px;
    // color: #80efff;
    color: #fff;
    letter-spacing: 1px;
    /* 文字不可选取 */
    user-select: none;
    position: fixed;
    left: 0;
  }

.userIcon {
  width: 37px;
  height: 35px;
  background: url("../assets/images/user.png") no-repeat 0 0;
  background-size: 100% 100%;
   margin-top: -25px;
   margin-right: 11px;
}

.login {
  font-size: 19px;
  font-weight: 400;
  color: #24d8ff;
  cursor: pointer;
  margin-top: -23px;
  margin-right: 11px;
}

.jlcmLog{
  width: 128px;
  height: 57px;
  // background: url("../assets/images/SUMHOO.png") no-repeat 0 0;
  background-size: 100% 100%;
  position: fixed;
  left: 30px;
  color: #fff;
  font-family: Arboria;
  text-align: center;
  font-size: 27px;
}
</style>